import React from 'react';
import './FinancialSolutionsTitle.css';

const FinancialSolutionsTitle = () => {
    return (
        <div className="financial-solutions-title-container">
            <h2 className="financial-solutions-title">
                Financial Solutions <span className="financial-solutions-highlight">Tailored For All Your Needs</span>
            </h2>
        </div>
    );
};

export default FinancialSolutionsTitle;
